import { ACTIONS } from '../const';

const { REMOVE_NOTIFICATION, NEW_NOTIFICATION, UPDATE_NOTIFICATION } = ACTIONS;

const timeouts = {};

export const genKey = () =>
    Math.floor(Math.random() * Math.pow(16, 6)).toString(16);

export function removeNotification(key) {
    if (timeouts[key] != null) {
        clearTimeout(timeouts[key]);
        delete timeouts[key];
    }
    return {
        type: REMOVE_NOTIFICATION,
        payload: key,
    };
}

export const newNotification = (title, text, options = {}) => dispatch => {
    const { key = genKey(), timeout, dismissable, icon } = options;

    if (timeout != null && timeout > 0) {
        timeouts[key] = setTimeout(() => {
            dispatch(removeNotification(key));
        }, timeout);
    }

    dispatch({
        type: NEW_NOTIFICATION,
        payload: {
            title,
            text,
            key,
            dismissable,
            icon,
        },
    });

    return key;
};

export const updateNotification = (key, options) => dispatch => {
    const {
        timeout = null,
        title = null,
        text = null,
        dismissable = null,
    } = options;

    if (timeout != null && timeout > 0) {
        if (timeouts[key] != null) {
            clearTimeout(timeouts[key]);
        }
        timeouts[key] = setTimeout(() => {
            dispatch(removeNotification(key));
        }, timeout);
    }

    return {
        type: UPDATE_NOTIFICATION,
        payload: {
            key,
            title,
            text,
            dismissable,
        },
    };
};



// WEBPACK FOOTER //
// ./src/actions/notifications.js